import React from 'react'
import Sidebar from 'blocks.app/sidebar/sidebar'
import translate from 'core/translate'
import { Conflicts } from '../../../pages/broadcasts/_add/broadcasts_add.local.methods'
import { Device } from '../../../pages/schedule/_add/schedule_add.local.methods'

interface IAddScheduleToolbar {
    devices: { id: number }[]
    devicesCount?: number
    conflicts: Conflicts[]
    onChangeDevices: (selected: Device[]) => void
    onClearSelectFromFile?: () => void
    selectFromFileMode?: boolean
    notSelectedDevices?: any
    onOptionsScroll?: (event: React.UIEvent<HTMLDivElement>) => void
    searchValue?: string
    onSearchChange?: (search: string) => void
    localSearch?: boolean
}

const AddScheduleToolbar = (p_: IAddScheduleToolbar) => {
    return (
        <Sidebar
            selectedSide="right"
            conflicts={p_.conflicts}
            content={{
                right: {
                    title: `${translate('countOfSelectedDisplays')} ${p_.devicesCount || p_.devices.length}`,
                    options: p_.devices,
                },
            }}
            selectFromFileMode={p_.selectFromFileMode}
            onClearSelectFromFile={p_.onClearSelectFromFile}
            notSelected={p_.notSelectedDevices}
            onChange={p_.onChangeDevices}
            onOptionsScroll={p_.onOptionsScroll}
            searchValue={p_.searchValue}
            onSearchChange={p_.onSearchChange}
            localSearch={p_.localSearch}
            isEmpty={{
                right:
                    p_.devices &&
                    p_.devices.length === 0 &&
                    p_.notSelectedDevices &&
                    p_.notSelectedDevices.length === 0,
            }}
            emptyText={{
                right: {
                    title: translate('noSelectedDevices'),
                    description: translate('noSelectedDevicesDescription'),
                },
            }}
        />
    )
}

export default AddScheduleToolbar
